export default "__VITE_ASSET__Cx469sFL__"